import React, { FC } from 'react';

import { useQueryString } from 'common/hooks';
import { useAuthStore } from 'common/stores';
import { Wrapper } from 'core/components/common';
import { OtpVerifyQueryParams } from 'core/router';
import { OtpVerifyForm, OtpVerifyFormProps } from 'features/components';

const OtpVerify: FC = () => {
  const {
    params: { otpAccessToken },
  } = useQueryString<OtpVerifyQueryParams>();

  const onSubmit: OtpVerifyFormProps['onSubimit'] = async ({ code }) => {
    const authStore = useAuthStore.getState();

    const account = await authStore.verifyOtpCode({
      otp: code,
      otpAccessToken,
    });

    if (!account) return;
  };

  return (
    <Wrapper internalClassName="!max-w-md">
      <OtpVerifyForm otpAccessToken={otpAccessToken} onSubimit={onSubmit} />
    </Wrapper>
  );
};

export default OtpVerify;
